import type React from 'react';

import { IconButton, type IconButtonProps, withStyles } from '@material-ui/core';

import Icon from '@cobliteam/ui/icons';

import { colors } from '../../styles';

export interface NavigateBeforeButtonProps extends IconButtonProps {
  fill?: string;
  hoverFill?: string;
  hoverBackground?: string;
}

const StyledNavigateBeforeButton = withStyles(() => ({
  root: {
    color: (props: NavigateBeforeButtonProps) => props.fill || colors.gray.default,
    padding: 0,

    '&:hover': {
      backgroundColor: (props: NavigateBeforeButtonProps) => props.hoverBackground || 'transparent',
      color: (props: NavigateBeforeButtonProps) => props.hoverFill || colors.gray.dark,
    },
  },
}))((props: NavigateBeforeButtonProps) => {
  const { fill, hoverFill, hoverBackground, ...otherProps } = props;

  return <IconButton {...otherProps} />;
});

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const NavigateBeforeButton: React.FC<NavigateBeforeButtonProps> = (props) => (
  <StyledNavigateBeforeButton disableRipple size='small' {...props}>
    <Icon name='chevron-left' />
  </StyledNavigateBeforeButton>
);
